import React, { FC } from 'react';
import { TRegularLink } from '../types/socialMediaBar.types';
import { googleSocialShareClickEvent } from '../../../../utils/analytics';
import { documentService } from '../../../../utils/window.utils';
import RoutableNotEditableLink from '../../routableNotEditableLink';
import Icon from '../../icon';
import { iconSize } from '../../../../constants/icon.constants';

const RegularLink: FC<TRegularLink> = (props) => {
  const { item, socialMediaButtonName } = props;

  return (
    <RoutableNotEditableLink
      href={''}
      className={`social-media-bar__social-icon-link a2a_button_${socialMediaButtonName}`}
      target="_blank"
      data-title={item.fields?.postText?.value}
      data-usefallback-window-title={true}
      data-is-page-url={true}
      onClick={() => googleSocialShareClickEvent(documentService()?.URL, item?.name)}
    >
      <Icon iconField={item?.fields?.icon} size={iconSize.mbl} />
    </RoutableNotEditableLink>
  );
};

export default RegularLink;
